import React from 'react';
import { ShieldCheck, Globe, Link, RefreshCcw, Mail } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-16 text-gray-800 text-start">
      <h1 className="text-6xl md:text-7xl font-bold mb-12 text-gray-700 text-start">
        Privacy Policy
      </h1>
      <p className="text-lg md:text-xl text-start mx-auto mb-12">
        At <span className="font-bold">Sarvagys Institute of Technology</span>, your privacy is our priority. 
        This Privacy Policy explains how we collect, use, and protect your personal information 
        when you interact with our website and services.
      </p>

      {/* Information We Collect */}
      <section className="mb-12">
        <h2 className="text-3xl font-bold mb-4 flex items-center gap-3">
          <ShieldCheck size={32} className="text-pink-500" /> Information We Collect
        </h2>
        <ul className="list-disc list-inside space-y-2 text-lg">
          <li>Data on how you interact with our website (analytics, usage patterns)</li>
          <li>Information you provide when registering for courses, newsletters, or contacting us</li>
          <li>Transaction details for courses or services requested</li>
          <li>Any other information you voluntarily provide via forms or emails</li>
        </ul>
      </section>

      {/* How We Use Your Information */}
      <section className="mb-12">
        <h2 className="text-3xl font-bold mb-4 flex items-center gap-3">
          <ShieldCheck size={32} className="text-pink-500" /> How We Use Your Information
        </h2>
        <ul className="list-disc list-inside space-y-2 text-lg">
          <li>Provide and manage courses, services, and your account</li>
          <li>Personalize your learning experience and website content</li>
          <li>Process payments, send confirmations, and relevant communications</li>
          <li>Share updates, news, and promotions (with your consent)</li>
        </ul>
        <p className="mt-4 text-lg">
          We may share your information with trusted partners or service providers strictly 
          for delivering our services. Legal requirements or protection of our rights may also 
          necessitate disclosure in certain circumstances.
        </p>
      </section>

      {/* Data Security */}
      <section className="mb-12">
        <h2 className="text-3xl font-bold mb-4 flex items-center gap-3">
          <ShieldCheck size={32} className="text-pink-500" /> Data Security
        </h2>
        <p className="text-lg">
          We implement robust security measures to protect your personal data from unauthorized 
          access, misuse, or disclosure. Sensitive information is encrypted where applicable, 
          and our systems are regularly monitored for security compliance.
        </p>
      </section>

      {/* International Transfers */}
      <section className="mb-12">
        <h2 className="text-3xl font-bold mb-4 flex items-center gap-3">
          <Globe size={32} className="text-pink-500" /> International Transfers
        </h2>
        <p className="text-lg">
          Some of your data may be stored or processed in countries outside your residence. 
          By using our services, you consent to such cross-border transfers, which comply with 
          applicable privacy regulations.
        </p>
      </section>

      {/* Third-Party Links */}
      <section className="mb-12">
        <h2 className="text-3xl font-bold mb-4 flex items-center gap-3">
          <Link size={32} className="text-pink-500" /> Third-Party Links
        </h2>
        <p className="text-lg">
          Our website may contain links to third-party websites. We are not responsible for 
          the privacy practices of these external sites. Please review their policies directly.
        </p>
      </section>

      {/* Policy Updates */}
      <section className="mb-12">
        <h2 className="text-3xl font-bold mb-4 flex items-center gap-3">
          <RefreshCcw size={32} className="text-pink-500" /> Policy Updates
        </h2>
        <p className="text-lg">
          This Privacy Policy may be updated periodically. Updates will be posted here, 
          and we encourage you to review it regularly to stay informed of any changes.
        </p>
      </section>

      {/* Contact */}
      <section className="mb-12">
        <h2 className="text-3xl font-bold mb-4 flex items-center gap-3">
          <Mail size={32} className="text-pink-500" /> Contact Us
        </h2>
        <p className="text-lg">
          For any questions, concerns, or requests regarding your personal information, 
          please reach out to us at <span className="font-semibold">Sarvagystech@gmail.com</span>.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
